import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, title }) => (
  <div className="mb-6 flex items-center gap-3" data-testid={`chapter-${number}`}>
    <span className="h-px w-12 bg-[#FF3B30]" aria-hidden />
    <span className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-[#FF3B30]">
      {number} · {title}
    </span>
  </div>
);
